import type { IComponentController, IScope } from "angular";
import { includes, remove } from "lodash";
import type { IFunctionalityMonitoring, IResponseWithLoading, ISite } from "App/Modules/Models";
import { SiteState, FunctionalityType } from "App/Modules/Models";
import type { ISiteFunctionalitiesRepository } from "App/Modules/Repositories/SiteFunctionalities/ISiteFunctionalitiesRepository";
import type { IPageService } from "App/Modules/Services";
import { extendWithLoadingAndFail } from "App/Modules/Services/ObservableExtensions";
import { finalize } from "rxjs/operators";

export default class FunctionalityListComponentController implements IComponentController {
    public static $inject: string[] = ["$scope", "irPageService", "mmSiteFunctionalitiesRepository"];

    public site: ISite;

    public functionalities: IResponseWithLoading<IFunctionalityMonitoring[]>;

    public testAlarmResponse: IResponseWithLoading<void>;

    public loadingFunctionalityIds: string[];

    constructor(
        private readonly $scope: IScope,
        private readonly pageService: IPageService,
        private readonly siteFunctionalitiesRepository: ISiteFunctionalitiesRepository,
    ) {}

    public $onInit() {
        this.loadingFunctionalityIds = [];
        if (this.site) {
            extendWithLoadingAndFail(this.siteFunctionalitiesRepository.getFunctionalitiesMonitoring(this.site.id))
                .pipe(finalize(() => this.$scope.$applyAsync()))
                .subscribe(
                    (response: IResponseWithLoading<IFunctionalityMonitoring[]>) => {
                        this.functionalities = response;
                    },
                    (error) => {
                        this.functionalities = error;
                    },
                );
        }
    }

    public sendTestSupervision(functionalityId: string): void {
        this.loadingFunctionalityIds.push(functionalityId);
        extendWithLoadingAndFail(
            this.siteFunctionalitiesRepository.sendTestAlarm(this.site.id, functionalityId),
        ).subscribe(
            (response: IResponseWithLoading<void>) => {
                this.testAlarmResponse = response;
                if (!response.isLoading) {
                    this.loadingFunctionalityIds = remove(this.loadingFunctionalityIds, functionalityId);
                }
            },
            (error) => {
                this.testAlarmResponse = error;
                this.loadingFunctionalityIds = remove(this.loadingFunctionalityIds, functionalityId);
            },
        );
    }

    public showLoader(functionalityId: string): boolean {
        return includes(this.loadingFunctionalityIds, functionalityId);
    }

    public isTestSupervisionAvailable(): boolean {
        return (
            this.site.functionalityTypes.includes(FunctionalityType.Care) &&
            (this.site.siteState === SiteState.Maintenance || this.site.siteState === SiteState.NotStarted)
        );
    }
}
